import React from "react";
import "./Anna_Sedlar.css";

const Anna_Sedlar = () => (

  <div className='Anna_SedlarMain'>
  <a href={"https://www.linkedin.com/in/annasedlar/"} target={"_blank"}><h3 className="text-center">Anna Sedlar</h3></a>

<p>I had the pleasure of working as a Teaching Assistant for Charles 
during the Georgia Tech Web Development Bootcamp. Charles was a 
absolute joy to have in class. His background in software programming 
helped not only him but the whole class as he generously and helpfully 
volunteered his knowledge, letting his peers make connections and hear 
another perspective on a technical topic. Charles always went above 
and beyond in assignments and projects, proving that he is open and 
eager to expand his technical skill set and truly enjoys the process of 
learning. I fully recommend Charles and I know whatever team he joins 
will be extremely lucky to have him!</p>

  </div>
);

export default Anna_Sedlar;


// WEBPACK FOOTER //
// ./src/components/AboutMe/Anna_Sedlar.js